import * as THREE from "three";
import ExtrudedLoopSubGeometry3d from "../compoundSceneGeometry/ExtrudedLoopSubGeometry3d";
import RectangleAnnotationData from "../sceneObjectData/RectangleAnnotationData";
import { getSceneObjectStyle, getSceneObjectStyleName, SceneObjectStyle, SceneObjectStyleEnum } from "./SceneObjectStyle";

import { LineMaterial } from "three/addons/lines/LineMaterial.js";

export default class RectangleAnnotationGeometry3d extends ExtrudedLoopSubGeometry3d<RectangleAnnotationData> {

    private static lineMaterialCache = new WeakMap<SceneObjectStyle, LineMaterial>();
    private static textMaterialCache = new WeakMap<SceneObjectStyle, THREE.MeshBasicMaterial>();

    private static getLineMaterial(style: SceneObjectStyle): LineMaterial {
        let mat = RectangleAnnotationGeometry3d.lineMaterialCache.get(style);
        if (!mat) {
            mat = new LineMaterial({
                color: style.color,
                linewidth: style.lineWidth,
                resolution: new THREE.Vector2(window.innerWidth, window.innerHeight)
            });
            mat.name = `RectangleAnnotation3d-${getSceneObjectStyleName(style)}-Line`;
            RectangleAnnotationGeometry3d.lineMaterialCache.set(style, mat);
        }
        return mat;
    }

    private static getTextMaterial(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        let mat = RectangleAnnotationGeometry3d.textMaterialCache.get(style);
        if (!mat) {
            mat = new THREE.MeshBasicMaterial({ color: style.color });
            mat.name = `RectangleAnnotation3d-${getSceneObjectStyleName(style)}-Text`;
            RectangleAnnotationGeometry3d.textMaterialCache.set(style, mat);
        }
        return mat;
    }

    constructor() {
        super(
            RectangleAnnotationGeometry3d.getLineMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal)),
            RectangleAnnotationGeometry3d.getTextMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal))
        );
    }

    protected getLineMaterialForStyle(style: SceneObjectStyle): LineMaterial {
        return RectangleAnnotationGeometry3d.getLineMaterial(style);
    }

    protected getTextMaterialForStyle(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        return RectangleAnnotationGeometry3d.getTextMaterial(style);
    }
}
